export default "__VITE_PUBLIC_ASSET__519a7676__"